// extracted by mini-css-extract-plugin
export default {"drawingBackground":"UploadBox_drawingBackground__Hx4y6"};